/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".folded:not(.unfolded)   [_nghost-%COMP%]   .nav-link[_ngcontent-%COMP%]   .happ-big-icon[_ngcontent-%COMP%]{font-size:45px;width:45px;height:45px;min-width:45px;min-height:45px;line-height:45px}.folded:not(.unfolded)   [_nghost-%COMP%]   .nav-link[_ngcontent-%COMP%] > .nav-link-badge[_ngcontent-%COMP%], .folded:not(.unfolded)   [_nghost-%COMP%]   .nav-link[_ngcontent-%COMP%] > .nav-link-title[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s ease}"];
export { styles as styles };
